<template>
  <div class="item-container">
    <div class="item-icon" @click="showContent">
      <div class="item-icon-img">
        <img :src="src" v-if="src" />
        <div v-if="score != undefined" class="item-score">{{ score }}</div>
      </div>

      <slot name="name">
        <div v-if="name" class="item-name">{{ name }}</div>
      </slot>
    </div>
    
    <div class="m-item-tips" v-show="show_tip && is_show"  @click="is_show=false">
      <div class="item-tips-content"  @click.stop="()=>{}">
        <slot name="title"></slot>
        <div ref="contentElement"></div>
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
import px2vw from '@/utils/px2vw';
import { text2html } from '@utils/utils';

const props = defineProps({
  content: {
    type: String,
    required: true,
  },
  src: {
    type: String,
    required: false,
  },
  size: {
    type: Number,
    default: 34,
    required: false,
  },
  name: {
    type: String,
  },
  title: {
    type: String,
  },
  score: {
    type: Number,
  },
  // computedStyle:{
  //   type: Object,
  // }
});

const contentElement = ref(null);
const show_tip = ref(false);
const is_show = ref(false);

const showContent = () => {
  is_show.value = true;
  if (props.content) {
    show_tip.value = true;
    text2html(props.content, contentElement.value);
  } else {
    show_tip.value = false;
  }
};

onMounted(async () => {});
</script>

<style scoped>
.m-item-tips {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10001;
}
</style>